function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4156 5.31992C15.4156 5.65301 15.1456 5.92305 14.8125 5.92305C14.4794 5.92305 14.2094 5.65301 14.2094 5.31992C14.2094 4.21204 15.1109 3.31055 16.2188 3.31055C17.3266 3.31055 18.2281 4.21204 18.2281 5.31992C18.2281 6.03485 17.8433 6.70181 17.2239 7.06013C16.9759 7.20357 16.8219 7.47005 16.8219 7.75616C16.8219 8.08924 16.5518 8.35928 16.2188 8.35928C15.8857 8.35928 15.6156 8.08924 15.6156 7.75616C15.6156 7.04124 16.0005 6.37427 16.6199 6.01595C16.8679 5.87254 17.0219 5.60602 17.0219 5.31992C17.0219 4.87699 16.6617 4.5168 16.2188 4.5168C15.7758 4.5168 15.4156 4.87699 15.4156 5.31992Z",
  fill: "#737373",
  stroke: "white",
  strokeWidth: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8219 10.2418C16.8219 10.5749 16.5518 10.8449 16.2188 10.8449C15.8857 10.8449 15.6156 10.5749 15.6156 10.2418C15.6156 9.9087 15.8857 9.63867 16.2188 9.63867C16.5518 9.63867 16.8219 9.9087 16.8219 10.2418Z",
  fill: "#737373",
  stroke: "white",
  strokeWidth: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48439 9.63867H8.58439V9.53867V1.10117C8.58439 0.768087 8.85443 0.498047 9.18751 0.498047H23.2969C23.63 0.498047 23.9 0.768087 23.9 1.10117V14.4605C23.9 14.7936 23.63 15.0637 23.2969 15.0637C22.9638 15.0637 22.6938 14.7936 22.6938 14.4605C22.6938 14.0176 22.3336 13.6574 21.8906 13.6574H15.5156H15.4156V13.7574V21.4918C15.4156 21.8249 15.1456 22.0949 14.8125 22.0949H2.10939C1.66645 22.0949 1.30626 22.4551 1.30626 22.898C1.30626 23.2311 1.03622 23.5012 0.703131 23.5012C0.370047 23.5012 0.100006 23.2311 0.100006 22.898V10.2418C0.100006 9.90871 0.370047 9.63867 0.703131 9.63867H8.48439ZM14.1094 20.8887H14.2094V20.7887V13.7574V13.6574H14.1094H3.51563C3.18255 13.6574 2.91251 13.3874 2.91251 13.0543C2.91251 12.7212 3.18255 12.4512 3.51563 12.4512H8.48439H8.58439V12.3512V10.9449V10.8449H8.48439H1.40626H1.30626V10.9449V20.9091V21.0507L1.43968 21.0034C1.6491 20.9291 1.87452 20.8887 2.10939 20.8887H14.1094ZM22.5603 12.5659L22.6938 12.6132V12.4716V1.8043V1.7043H22.5938H9.89063H9.79063V1.8043V12.3512V12.4512H9.89063H21.8906C22.1255 12.4512 22.3509 12.4916 22.5603 12.5659Z",
  fill: "#737373",
  stroke: "white",
  strokeWidth: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.51563 18.0762H12C12.3331 18.0762 12.6031 18.3462 12.6031 18.6793C12.6031 19.0124 12.3331 19.2824 12 19.2824H3.51563C3.18255 19.2824 2.91251 19.0124 2.91251 18.6793C2.91251 18.3462 3.18255 18.0762 3.51563 18.0762Z",
  fill: "#737373",
  stroke: "white",
  strokeWidth: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.51563 16.4699C3.18255 16.4699 2.91251 16.1999 2.91251 15.8668C2.91251 15.5337 3.18255 15.2637 3.51563 15.2637H12C12.3331 15.2637 12.6031 15.5337 12.6031 15.8668C12.6031 16.1999 12.3331 16.4699 12 16.4699H3.51563Z",
  fill: "#737373",
  stroke: "white",
  strokeWidth: 0.2
});

var SvgHelpIcon = function SvgHelpIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-icon.614ed1ca.svg";
export { ForwardRef as ReactComponent };